<template>
  <div>
    <v-text-field
      v-model="bikeSerialNumber"
      :label="$t('filter.sparePartsFinder.boxSerialInputLabel')"
      outlined
      dense
      :hide-details="!hasBikeSerialNumberError"
      autocomplete="off"
      :error-messages="
        hasBikeSerialNumberError
          ? $t('filter.sparePartsFinder.boxSerialInputErrormessage')
          : undefined
      "
      @keyup.enter="searchByBikeSerialNumber"
    >
      <template #append>
        <v-btn
          v-show="bikeSerialNumber"
          icon
          small
          :height="36"
          :width="36"
          :elevation="0"
          class="mr-3"
          @click="clearBikeSerialNumber"
        >
          <v-icon medium>mdi-close-circle</v-icon>
        </v-btn>
        <v-btn
          v-if="!isSnSearch"
          color="primary"
          :disabled="!searchByBikeSerialNumberAllowed"
          icon
          small
          :height="36"
          :width="36"
          :elevation="0"
          @click="searchByBikeSerialNumber"
        >
          <v-icon large>mdi-magnify</v-icon>
        </v-btn>
        <AztecCameraScanner v-if="isSnSearch" @scanResult="updateAztec" />
      </template>
    </v-text-field>
    <v-btn
      v-if="isSnSearch"
      color="primary"
      :disabled="!searchByBikeSerialNumberAllowed"
      style="
        width: 100%;

        border-radius: 999px;
      "
      type="submit"
      class="mx-0 mt-6 rounded-full"
      @click="searchByBikeSerialNumber"
      >{{ $t('account.backorder.searchlabel') }}</v-btn
    >
  </div>
</template>

<script>
import { get, isUndefined } from 'lodash-es'
import AztecCameraScanner from '@/js/components/Zxing/AztecCameraScanner.vue'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'

export default {
  name: 'SparePartsSearchBar',

  components: {
    AztecCameraScanner,
  },
  props: {
    serialNumber: {
      type: String,
      default: undefined,
    },
    isSnSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bikeSerialNumber: this.serialNumber,
      langBase: 'service-warranty',
    }
  },
  computed: {
    hasBikeSerialNumberError() {
      if (isUndefined(this.bikeSerialNumber)) {
        return false
      }
      return false
    },
    searchByBikeSerialNumberAllowed() {
      return (
        !(
          isUndefined(this.bikeSerialNumber) ||
          this.bikeSerialNumber.length < 7 ||
          this.hasBikeSerialNumberError
        ) && this.currentRouteSerialNumber !== this.bikeSerialNumber
      )
    },
    currentRouteSerialNumber() {
      return get(this.$route, ['params', 'serialNumber'])
    },
    searchByBikeSerialNumberLink() {
      if (this.searchByBikeSerialNumberAllowed && !this.isSnSearch) {
        return {
          name: `${FILTER_CONSTANTS.SCOPE.SERVICE}-sn`,
          params: {
            serialNumber: this.bikeSerialNumber,
            listLink: get(this.$route, ['params', 'listLink']),
          },
        }
      } else if (this.searchByBikeSerialNumberAllowed && this.isSnSearch) {
        return {
          name: `serial-number-search`,
          params: {
            serialNumber: this.bikeSerialNumber,
            listLink: get(this.$route, ['params', 'listLink']),
          },
        }
      } else {
        return undefined
      }
    },
  },
  methods: {
    searchByBikeSerialNumber() {
      if (!this.searchByBikeSerialNumberAllowed) {
        return
      }

      const link = this.searchByBikeSerialNumberLink
      this.$router.push(link)
    },
    checkInitial(keyword) {
      let currentPath = this.$route.path
      console.log(currentPath.endsWith(keyword) || currentPath.endsWith(keyword + '(/|$)'))
      return currentPath.endsWith(keyword) || currentPath.endsWith(keyword + '(/|$)')
    },
    clearBikeSerialNumber() {
      this.bikeSerialNumber = undefined
    },
    updateAztec(sn) {
      if (this.checkInitial('serialnumbersearch')) {
        let numberToAppend = sn

        // Get the current path
        let currentPath = this.$route.path

        // Construct the new path by appending the number
        let newPath = `${currentPath}/${numberToAppend}`
        this.$router.push(newPath)
      } else if (!this.checkInitial('serialnumbersearch')) {
        this.$router.push(sn)
      }
    },
  },
}
</script>

<style lang="scss" module></style>
